module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "min-height": "800px",
      "position": "relative"
    }
  }, [(_vm.backURL == '') ? _c('div', {
    staticClass: "system"
  }, [_c('div', {
    staticClass: "btnBox"
  }, [_c('div', {
    staticClass: "btn",
    staticStyle: {
      "margin-bottom": "130px"
    },
    on: {
      "click": function($event) {
        return _vm.goSystem(1)
      }
    }
  }, [_vm._v("运营系统")]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.goSystem(2)
      }
    }
  }, [_vm._v("报价系统")])])]) : _vm._e(), _vm._v(" "), (_vm.backURL && !_vm.isLogin) ? _c('div', {
    staticClass: "login-bg",
    staticStyle: {
      "position": "relative"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleLogin($event)
      }
    }
  }, [_c('div', {
    staticClass: "login-container"
  }, [_c('el-form', {
    ref: "loginForm",
    staticClass: "demo-ruleForm login-form",
    attrs: {
      "model": _vm.loginForm,
      "rules": _vm.loginFormRules,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [(_vm.type == 1) ? _c('h3', {
    staticClass: "title"
  }, [_vm._v("云半径运营管理平台")]) : _vm._e(), _vm._v(" "), (_vm.type == 2) ? _c('h3', {
    staticClass: "title"
  }, [_vm._v("旺龙在线报价系统")]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "account"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "maxlength": 30,
      "placeholder": "账号",
      "autofocus": true
    },
    model: {
      value: (_vm.loginForm.account),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "account", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "loginForm.account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "maxlength": 16,
      "placeholder": "密码",
      "onpaste": "return false",
      "oncontextmenu": "return false",
      "oncopy": "return false",
      "oncut": "return false"
    },
    model: {
      value: (_vm.loginForm.password),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "password", $$v)
      },
      expression: "loginForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "verificationCode"
    }
  }, [_c('el-input', {
    staticClass: "codeInput",
    staticStyle: {
      "width": "65%"
    },
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "验证码",
      "maxlength": 4
    },
    model: {
      value: (_vm.loginForm.verificationCode),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "verificationCode", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "loginForm.verificationCode"
    }
  }), _vm._v(" "), (_vm.imgFlag) ? _c('img', {
    staticClass: "code",
    attrs: {
      "src": _vm.imgUrl,
      "width": "100",
      "height": "60"
    },
    on: {
      "click": _vm.getVerificationCode
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.loginLoading
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleLogin($event)
      }
    }
  }, [_vm._v("登录\n                   ")])], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.yun-r.com/about",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("关于我们")]), _vm._v("  |  "), _c('a', {
    attrs: {
      "href": "https://www.yun-r.com/about/show.php?lang=cn&id=15",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("联系我们")])]), _vm._v(" "), _c('div', [_vm._v("深圳市旺龙智能科技有限公司")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#a6d0ff",
      "margin-bottom": "8px"
    }
  }, [_vm._v("\n           © 1997-2023 深圳市旺龙智能科技有限公司 All rights reserved.\n           "), _c('a', {
    staticStyle: {
      "color": "#a6d0ff",
      "font-size": "16px"
    },
    attrs: {
      "href": "https://beian.miit.gov.cn/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("粤ICP备18085992号")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1724690d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Login.vue
// module id = 919
// module chunks = 1